import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHeading } from "../../../redux/slice/headerSlice";
import { useNavigate } from "react-router-dom";
import Header from "../../layout/Header";
import { formatPoints } from "../../../utils/helper";

const RouteInvoice = () => {
  const dispatch = useDispatch();
  const tiers = localStorage.getItem("customerTier");
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(setHeading("Upload Invoice"));
  }, []);


  let points = 0;
  if (tiers === "Silver") points = 100;
  else if (tiers === "Gold") points = 150;
  else if (tiers === "Platinum") points = 200;
  else if (tiers === "Founder Club") points = 250;


  const industry = localStorage.getItem('industry');
  const industryTransactionMap = {
    'White Goods': 10000,
    'Steel': 10000,
    'Battery': 10000,
    'Ceramics': 10000,
    'Construction': 10000,
    'Spare': 10000,
    'Footwear': 10000,
    'Glass & Plywood': 10000,
    'Plywood': 10000,
    'Glass': 10000,
    'Mobile': 20000,
    '2 Wheelers': 12500,
    'Agri Inputs': 8000,
    "FMCG": 10000
  };
  const transactionValue = industryTransactionMap[industry]

  const routeSteps = [
    {
      icon: "/images/upload.png",
      bgClass: "bluebg",
      title: "Upload Invoices",
      description: `${points} points for every ₹ ${formatPoints(transactionValue)} invoice value`,
    },
    {
      icon: "/images/earn_points.png",
      bgClass: "greenbg",
      title: "Earn Points",
      description: "Points credited when the invoice gets disbursed",
    },
    {
      icon: "/images/rewards.png",
      bgClass: "yellowbg",
      title: "Win Rewards",
      description: "Redeem points when the retailer repays on time without going into OD",
    },
  ];
  const goToPreviousTab = () => {
    navigate(-1);
  };


  return (
    <>
      <Header goToPreviousTab={goToPreviousTab} isHomePage={false} />
      <main>
        <div className="route-invoice bluebg">
          <h4 className="route-invoice-top">
            Route All Invoices via Progcap
          </h4>
          <p>
            Upload every invoice on Progcap to earn maximum points and win an
            international trip every month!
          </p>
        </div>

        {routeSteps.map((step, index) => (
          <div key={index} className="route-box">
            <span className={`route-box-icon ${step.bgClass}`}>
              <img src={step.icon} alt={`${step.title} Icon`} />
            </span>
            <h4>{step.title}</h4>
            <p>{step.description}</p>
          </div>
        ))}

        <div className="route-pushBox bluebg">
          <div className="route-pushBox-left">
            <img src="/images/upload_invoice.png" alt="Upload Invoice" />
          </div>
          <div className="route-pushBox-right">
            <h4>Where to Upload Invoices?</h4>
            <p>You can upload invoices the usual way-either directly through the Progcap app or via ERP sync.</p>
          </div>
        </div>
      </main>
    </>
  );
};

export default RouteInvoice;
